import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import SportbookPage from './pages/SportbookPage';
import LoginModal from './components/LoginModal';
import UserInfoModal from './components/UserInfoModal';
import './App.css';

// App content component to access auth context
const AppContent = () => {
    const { setShowLoginModal } = useAuth();

    // Listen for messages from iframe
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data) {
                switch (event.data.type) {
                    case 'SPORTBOOK_BACK':
                        // Handle back action from sportbook iframe
                        break;
                    case 'SPORTBOOK_LOGIN':
                        // Show login modal
                        setShowLoginModal(true);
                        break;
                    default:
                        break;
                }
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [setShowLoginModal]);

    // Listen for custom event to show login modal
    useEffect(() => {
        const handleShowLogin = () => {
            setShowLoginModal(true);
        };

        window.addEventListener('winburst:showLogin', handleShowLogin);
        return () => window.removeEventListener('winburst:showLogin', handleShowLogin);
    }, [setShowLoginModal]);

    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/sportbook" element={<SportbookPage />} />
                <Route path="/sportsbook/*" element={<HomePage />} />
            </Routes>
            <LoginModal />
            <UserInfoModal />
        </div>
    );
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <AppContent />
            </Router>
        </AuthProvider>
    );
}

export default App;
